import { ThunkType } from "../../../../core/store/reducers";
import { setFloatingOrderInd } from "../orderIndDataReducer";
import getAllOrderIndApi from "../api/getAllOrderInd";
import { OrderIndFilter } from "../types";

export const loadAllOrderIndFloating = (
	filter?: OrderIndFilter
): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	const user = store.data.auth.current.user;

	const today = new Date().toISOString();

	const finalFilter: OrderIndFilter = {
		datefrom: today,
		dateto: today,
		status: 1,
		side: filter?.side,
	};

	const orderIndResponse = await dispatch(
		getAllOrderIndApi(user, 0, 100, finalFilter)
	);

	if (!orderIndResponse || orderIndResponse.resCode !== "OK") {
		return;
	}

	dispatch(setFloatingOrderInd(orderIndResponse.obj || []));
};